/**
 * Formats string with arguments
 * @param text Text to format
 * @param args Array of arguments
 * @returns Formatted text
 */
export function stringFormat(text: string, args: string[]): string {
    if (!args.length || !text) {
      return text;
    }
  
    for (let i = 0; i < args.length; i++) {
      text = text.replace(`{${i}}`, args[i]);
    }
  
    return text;
}